<template>
    <b-collapse class="group-frame">
        <div
            slot="trigger"
            slot-scope="slotProps"
            class="card-header"
            role="button">
            <p class="card-header-title">
                <tr-text class="column" v-bind="props.label" :tracker="tracker"
                    @edit-tr="$emit('edit-tr', $event)"></tr-text>
            </p>
            <a class="card-header-icon">
                <b-icon
                    :icon="slotProps.open ? 'caret-down' : 'caret-up'">
                </b-icon>
            </a>
        </div>
        <div class="card-content">
            <component :is="child.tag" v-for="(child, idx) in children" :key="idx"
                v-bind="child"
                :index="idx"
                :tracker="tracker"
                :showLabel="true"
                @edit-tr="$emit('edit-tr', $event)"
            ></component>
        </div>
    </b-collapse>
</template>

<script>
import TrText               from "@/components/translation/TrText"
import I18nText             from "@/components/i18n/I18nText"
import I18nEditbox          from "@/components/i18n/I18nEditbox"
import I18nCheckbox         from "@/components/i18n/I18nCheckbox"
import I18nCombobox         from "@/components/i18n/I18nCombobox"
import I18nGetsum           from "@/components/i18n/I18nGetsum"

export default {
    name: "I18nGroupAccordion",
    components: {TrText, I18nText, I18nEditbox, I18nCheckbox, I18nCombobox, I18nGetsum},
    props: {
        tracker: Array,
        index: Number,
        children: Array,
        props: Object,
        showLabel: {default: true}
    }
}
</script>

<style scoped>
    .group-frame {
        border: 1px solid black;
        padding: 0.5em;
    }

</style>